<template>
  <div class="accountSecurity">
    <div class="wrapper">
      <div class="head flex-rowl">
        <div class="icon"><i class="iconfont icon-anquan"></i></div>
        <div class="main">
          <div class="txt1">安全中心</div>
          <div class="txt2">账号安全及密保管理</div>
        </div>
      </div>

      <div class="list">
        <router-link to="/mineIndex/setPwd" class="item flex-between">
          <div class="con pwd_icon flex-rowc">
            <i class="iconfont icon-31mima"></i> 登录密码管理
          </div>
          <div class="custom_btn">设置/修改密码</div>
        </router-link>
        <div class="item flex-between" @click="handleToast">
          <div class="con email_icon flex-rowc">
            <i class="iconfont icon-youxiang"></i> 绑定安全邮箱
          </div>
          <div class="custom_btn">设置/修改安全邮箱</div>
        </div>
        <div class="item flex-between"  @click="handleToast">
          <div class="con pro_icon flex-rowc">
            <i class="iconfont icon-wentiguanli"></i> 安全问题设置
          </div>
          <div class="custom_btn">设置/修改安全问题</div>
        </div>
      </div>

      <div class="custom_btn return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "accountSecurity",
  data() {
    return {
      searchTxt: "",
    };
  },
  methods: {
    handleReturn() {
      this.$router.back();
    },
    handleToast() {
      this.$toast('即将开放')
    }
  },
};
</script>
<style lang="less" scoped>
.accountSecurity {
  background: #fafafa;
  height: 100vh;
  .head {
    background: #fafafa;
    padding: 149px 0 31px 80px;
    font-size: 30px;
    color: #333333;
    box-sizing: border-box;
    .txt2 {
      font-size: 20px;
      margin-top: 7px;
    }
    .iconfont {
      font-size: 44px;
      margin-right: 15px;
    }
  }

  .list {
    font-size: 24px;
    .item {
      background: #fff;
      height: 160px;
      padding: 0 48px 0 82px;
      margin-bottom: 10px;
      .con {
        color: #333333;
      }
      .iconfont {
        margin-right: 15px;
        font-weight: 400;
        color: #333333;
        font-size: 36px;
        &.icon-wentiguanli {
          font-size: 30px;
        }
      }
    }
    .custom_btn {
      width: 280px;
      height: 50px;
      line-height: 50px;
      font-size: 20px;
      margin: 0;
    }
  }
  .custom_btn.return {
    margin-top: 160px;
  }
}
</style>